import {
    SET_MAPPING_OPTIONS,
    UPDATE_BULK_DATA,
    SET_CURRENT_STEP,
    CLEAR_DATA,
    UPDATE_HEADER_MAPPING,
    TOGGLE_PRODUCT_SERVICE
} from '../actions/types';
import { getJdMartParams } from '../utills';
import axios from 'axios';

export const uploadFileForBulkUpload = (params) => (dispatch, getState) => {
    var formData = new FormData();
    formData.append('file', params.fileData);
    const state = getState();
    let jdMartParams = getJdMartParams();
    let url = '/marketplace/static/php/web/b2bWebsite.php?token='+ state.session.token +'&action=uploadProductFile';
    url += `&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}&sourceFlag=${state.session.viaOmni ? '1': ''}`
    if (params.bulkUploadServices){
        url+='&bulkType=service';
    }
    if(params.transactionType){
        url+='&transactionType='+params.transactionType;
    }
    if(params.categoryWiseBulk){
        url+= `&keywordId=${params.catData.keywordId}` ;
    }
    axios({
        method: 'POST',
        url: url,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((res) => {
        console.log(res);
        if(!res.data.isSuccess){
            params.cb && params.cb(false, res.data.msg);
        }
        else{
            dispatch({
                type : UPDATE_BULK_DATA,
                payload : {
                    headerMapping: res.data.headerMapping,
                    mappingOptions: res.data.mappingOptions,
                    fileId: res.data.fileId || '',
                    // sampleRow: res.data.sampleRow
                }
            });
            setTimeout(()=>{
                params.cb && params.cb(true);
            },1000)
        }
    })
}

export const updateHeaderMapping = (params) => (dispatch, getState) => {
    dispatch({
        type : UPDATE_HEADER_MAPPING,
        payload : params
    });
}

export const setCurrentStep = (params) => (dispatch, getState) => {
    dispatch({
        type: SET_CURRENT_STEP,
        payload: params
    })
}

export const clearBulkUploadData = (params) => (dispatch, getState) => {
    dispatch({
        type: CLEAR_DATA,
        payload: params
    })
}

export const updateBulkData = (params) => (dispatch, getState) => {
    dispatch({
        type : UPDATE_BULK_DATA,
        payload : params
    });
}

export const toggleBulkProductService = (params) => (dispatch, getState) => {
    dispatch({
        type : TOGGLE_PRODUCT_SERVICE,
        payload : params
    });
}